import React from "react";
import { Rich } from "../rich";
import * as styles from "./Advantages.module.scss";
import type { RichText } from "@shared/arrays/pop-ups-shared";

export interface Advantage {
  title: string;
  text: RichText;
  image?: string;
}

export interface AdvantagesProps {
  title: string;
  /** The export's own headline for the block, kept as copy under the new one. */
  lead?: string;
  intro?: string;
  items: Advantage[];
  /** A footnote the export placed under the list; it sits on grey, not black. */
  note?: string;
}

export function Advantages({ title, lead, intro, items, note }: AdvantagesProps) {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <header className={styles.head}>
          <h2 className={styles.heading}>{title}</h2>
          {lead && <p className={styles.lead}>{lead}</p>}
          {intro && <p className={styles.intro}>{intro}</p>}
        </header>

        <ul className={styles.grid}>
          {items.map((item) => (
            <li key={item.title} className={styles.card}>
              {item.image && (
                <img
                  className={styles.icon}
                  src={item.image}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  decoding="async"
                />
              )}
              <h3 className={styles.title}>{item.title}</h3>
              <p className={styles.text}>
                <Rich parts={item.text} />
              </p>
            </li>
          ))}
        </ul>

        {note && <p className={styles.note}>{note}</p>}
      </div>
    </section>
  );
}

export default Advantages;
